import { Tooltip } from "@chakra-ui/react";
import { ErrorBoundary } from "react-error-boundary";
import { useOrganization } from "src/hooks/useOrganization";
import * as format from "src/services/format";
import { isNonEmptyString } from "src/services/predicates";

type Props = {
  isoDate: string | null | undefined;
};

export const OrganizationDateView = (props: Props) => {
  return (
    <ErrorBoundary fallback={<>{props.isoDate}</>}>
      <OrganizationDateTooltip {...props} />
    </ErrorBoundary>
  );
};

const OrganizationDateTooltip = ({ isoDate }: Props) => {
  const organization = useOrganization();

  if (!isNonEmptyString(isoDate)) {
    return isoDate;
  }

  return (
    <Tooltip
      hasArrow
      label={format.formatIsoDateToOrgDateTime(isoDate, organization)}
    >
      {format.formatIsoDateToOrgDate(isoDate, organization)}
    </Tooltip>
  );
};
